import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Col } from 'react-bootstrap';
import { calcResize } from 'components/Layout/styles';
import { Link } from 'gatsby';
import { mediaBreakpointUp } from 'utils/styledCssHelpers';

// Section title
export const STitle = styled.h3``;
export const SLink = styled(Link)`
  display: block;
  width: 100%;
`;

export const SCardCol = styled(Col)`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`;

export const SPostCardImageBox = styled.div`
  height: ${props => props.height || '150'}px;
  overflow: hidden;
  position: relative;

  ${mediaBreakpointUp('xl', `height: 220px`)}

  &::before {
    position: absolute;
    // content: '';
    width: 100%;
    height: 60%;
    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, #252525 100%);
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      color-stop(0%, rgba(0, 0, 0, 0)),
      color-stop(100%, #252525)
    );
    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, #252525 100%);
    background: -o-linear-gradient(top, rgba(0, 0, 0, 0) 0%, #252525 100%);
    background: -ms-linear-gradient(top, rgba(0, 0, 0, 0) 0%, #252525 100%);
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, #252525 100%);
    bottom: 0;
    left: 0;
    z-index: 2;
    transition: height 0.2s;
    backface-visibility: hidden;
  }
  &:hover::before {
    height: 0%;
  }
`;

export const SPostCardImage = styled(GatsbyImage)`
  position: initial !important;
`;

export const SPostCardTitle = styled.h3`
  margin-bottom: 10px;
  z-index: 2;
  margin-bottom: 5px;
  font-size: ${calcResize(14, 20)};
  line-height: 1.2;
  font-weight: bold;
  background: transparent;
  cursor: pointer;

  span {
    color: ${props => props.theme.colors.light_grey};
    font-weight: 400;
  }
`;

//prettier-ignore
export const SPostCardFooter = styled.div`
  width: 100%;
  padding: ${props => (props.inverse ? 0 : 20)}px;
  border: ${props => (props.inverse ? 'none' : `1px solid ${props.theme.colors.grey}`)};
  flex: 1;
  display: flex;
  flex-direction: column;

  background: ${props => (props.inverse ? 'transparent' : '#ffffff')};
`;

export const SPostReadTime = styled.p`
  color: ${props => props.theme.colors.light_grey};
  font-weight: 300;
  font-size: ${calcResize(15, 18)};
  align-self: flex-start;
`;

export const SCategoryName = styled.span`
  position: absolute;
  left: 25px;
  top: 15px;
  z-index: 100;
  background: ${props =>
    props.inverse ? props.theme.colors.primary : props.theme.colors.accent};
  padding: 5px 10px;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 10px;
  a {
    color: #fff !important;
  }
`;

export const SExcerpt = styled.div`
  margin: 10px 0px;
  color: ${props => props.theme.colors.dark_grey};
  font-size: ${calcResize(12, 17)};
  text-align: justify;
`;

export const SReadMore = styled(Link)`
  font-weight: bold;
  text-transform: uppercase;
  font-size: ${calcResize(13, 15)};
  color: ${props => props.theme.colors.primary} !important;
  justify-self: flex-end;
  margin: 8px 0px;
`;

export const SPostAuthorContainer = styled.section`
  display: flex;
  align-items: center;
  margin: 15px 0;
  display: flex;
  align-items: center;
  align-content: center;
  font-weight: 300;
  font-size: ${calcResize(12, 14)};
  span.content {
    font-size: inherit;
    margin-left: 5px;
    color: ${props =>
      props.inverse ? props.theme.colors.primary : props.theme.colors.p};
  }
`;

export const SPostAuthorAvatar = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
`;

export const SPostAuthorName = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
`;

export const SPostCreatedDate = styled.div`
  display: flex;
  align-items: center;
  align-content: center;

  // margin-left: 15px; // enable when the avatar gets enabled
  .calendar_svg {
    fill: ${props =>
      props.inverse
        ? props.theme.colors.primary
        : props.theme.colors.dark_gray};
  }
`;
